import { vestingSlice } from '../vestingInfoSlice';

export const { cleanVestingInfo } = vestingSlice.actions;
